module.exports = __webpack_public_path__ + "img/9e1f8c0b749d3b1a12ddb01db4e72c6c.svg";